/**
 * The Content-Type of an LearningSectionContainer
 */
export enum LearningSectionContainerContentType {
  EXPLANATION = 'ExplanationJsonModel',
  SEQUENCE = 'SequenceJsonModel',
  EXPLANATION_CONTENT = 'ExplanationContentJsonModel',
  TEST = 'TestJsonModel',
}

export const LearningSectionContainerContentTypes = [
  { model: LearningSectionContainerContentType.EXPLANATION, label: 'Erkläreinheit' },
  { model: LearningSectionContainerContentType.SEQUENCE, label: 'Lerneinheit' },
  { model: LearningSectionContainerContentType.EXPLANATION_CONTENT, label: 'Pixl-Inhalt' },
  { model: LearningSectionContainerContentType.TEST, label: 'Test' },
];

export const getLearningSectionContainerContentType = (modelName: string) => {
  return LearningSectionContainerContentTypes.find(option => option.model === modelName);
};
